// deps
import { useContext } from "react";

// internal-deps
import { isEmpty } from "@swiggy-private/js-utils";
import { IPLWidgetControllerCards } from "@swiggy-private/dls-react-mxn/dist/WidgetController/PLWidgetController/type";
import {
    QrCodeActions,
    ResponseContext,
    SwiggyContextHeader,
    TableContext,
    usePlApiContextFetch,
} from "@swiggy-private/portal-dineout-context";

// constants
import { API_ENDPOINTS, GANDALF_API_HOST, LOG_TABLES, STORAGE_KEYS } from "../constants";

// utils
import { getDefaultApiHeaders } from "../utils/api";

export const useUpdateCart = () => {
    const fetchPL = usePlApiContextFetch();
    const { swiggyHeaders } = useContext(SwiggyContextHeader);
    const { tableId = "", restaurantId = "", parentOrderId = "" } = useContext(TableContext);
    const { dispatch } = useContext(ResponseContext);

    const updateCart = async (payload: Record<string, unknown>) => {
        if (!swiggyHeaders) {
            return Promise.reject(new Error("Missing swiggyHeaders"));
        }

        try {
            const updatedPayload = {
                ...payload,
                restaurantId: Number(restaurantId),
                tableId,
                parentOrderId,
            };

            const response = await fetchPL?.<{ cards: IPLWidgetControllerCards[] }>(
                {
                    apiHost: GANDALF_API_HOST,
                    endpoint: API_ENDPOINTS.UPDATE_CART,
                    bodyParams: updatedPayload,
                    options: {
                        method: "POST",
                        headers: { ...swiggyHeaders, ...getDefaultApiHeaders(swiggyHeaders) } as HeadersInit,
                    },
                },
                { ...swiggyHeaders, ...getDefaultApiHeaders(swiggyHeaders) },
                () => {},
                LOG_TABLES,
            );

            if (!isEmpty(response) && response.success) {
                dispatch({
                    type: QrCodeActions.CART_UPDATE_SUCCESS,
                    payload: { response },
                });

                dispatch({
                    type: QrCodeActions.UPDATE_LOCAL_CART,
                    payload: updatedPayload,
                });

                try {
                    sessionStorage.setItem(STORAGE_KEYS.LOCAL_CART, JSON.stringify(updatedPayload));
                } catch (_) {}
            }
        } catch (error) {
            dispatch({
                type: QrCodeActions.CART_UPDATE_ERROR,
                payload: {},
            });
        }
    };

    return { updateCart };
};
